import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api'
import { useThemeModel } from '@entities/theme'
import { AddingMenu } from '@features/menu'
import { MenuNotification } from '@entities/menu'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderEmpty',
  setup(__props) {

const activeBaseAlert = ref(false)

const toggleBaseAlert = (value: boolean) => {
  activeBaseAlert.value = value
}

const themeModel = useThemeModel()
const onBackground = () => {
  activeBaseAlert.value = false
}


return { __sfc: true,activeBaseAlert, toggleBaseAlert, themeModel, onBackground, AddingMenu, MenuNotification }
}

})